import {
  SHOW_MODAL_FOR_DOMAIN_PART,
  HIDE_MODAL_FOR_DOMAIN_PART,
  UPDATE_MODAL_LAYOUT_DATA,
  MINIMIZE_MODAL_FOR_DOMAIN_PART,
  RESTORE_MODAL_FOR_DOMAIN_PART,
  CLOSE_ALL_OPENED_MODALS,
} from './types';

/** Create action which to lead to the modal shown for a part
 * @param {String} partId - the id of the part of the domain that is clicked
 * @return {Object} Return type and partId
 */
export function showModalForDomainPart(partId) {
  return {
    type: SHOW_MODAL_FOR_DOMAIN_PART,
    payload: {
      partId,
    },
  };
}

/** Create action which to hide the modal shown for a part
 * @param {String} partId - the id of the part of the domain whose modal should be hidden
 * @return {Object} Return type and partId
 */
export function hideModalForDomainPart(partId) {
  return {
    type: HIDE_MODAL_FOR_DOMAIN_PART,
    payload: {
      partId,
    },
  };
}

/** Create action which to minimize the modal shown for a part
 * @param {String} partId - the id of the part of the domain whose modal should be minimized
 * @return {Object} Return type and partId
 */
export function minimizeModalForDomainPart(partId) {
  return {
    type: MINIMIZE_MODAL_FOR_DOMAIN_PART,
    payload: {
      partId,
    },
  };
}

/** Create action which to restore the modal shown for a part
 * @param {String} partId - the id of the part of the domain whose modal should be restored
 * @return {Object} Return type and partId
 */
export function restoreModalForDomainPart(partId) {
  return {
    type: RESTORE_MODAL_FOR_DOMAIN_PART,
    payload: {
      partId,
    },
  };
}

/** Create action which to save the layout after user does resize or reorder
 * @param {Object} newLayoutData - the new layout data
 * @return {Object} Return type and partId
 */
export function updateModalLayoutAfterResize(newLayoutData) {
  return {
    type: UPDATE_MODAL_LAYOUT_DATA,
    payload: {
      newLayoutData,
    },
  };
}

/** Create action which to close all opened modals at once
 * @return {Object} Return type and partId
 */
export function closeAllOpenedModals() {
  return {
    type: CLOSE_ALL_OPENED_MODALS,
    payload: {},
  };
}
